import { withLocalize } from 'react-localize-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import useStore from '../store/useStore';

function Landing() {
  // const {
  //   params: { locale: languageCode }
  // } = match;

  const languageCode = useStore(state => state.language);

  const location = useLocation();

  const match = location.pathname?.split('/')?.[3];

  const navigate = useNavigate();

  const content = () => {
    switch (match) {
      case 'golfhaftet':
      case 'sgf':
        navigate(`/${languageCode}`);
        return null;
      case 'app':
        navigate(`/${languageCode}/app`);
        return null;
      case 'oob': {
        navigate(`/${languageCode}`);
        return null;
      }
      default:
        navigate(`/${languageCode}/404`);
        return null;
    }
  };

  return content();
}

export default withLocalize(Landing);
